<script setup>

</script>
<template>
  <i class="aside-menu mail-type">
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M4 4.16666H16C16.825 4.16666 17.5 4.82291 17.5 5.625V14.375C17.5 15.1771 16.825 15.8333 16 15.8333H4C3.175 15.8333 2.5 15.1771 2.5 14.375V5.625C2.5 4.82291 3.175 4.16666 4 4.16666Z" stroke="url(#paint0_linear_284_201)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.5 5.83334L10 10.8333L2.5 5.83334" stroke="url(#paint1_linear_284_201)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
      <linearGradient id="paint0_linear_284_201" x1="10" y1="4.16666" x2="10" y2="15.8333" gradientUnits="userSpaceOnUse">
        <stop stop-color="#3A86FF"/>
        <stop offset="1" stop-color="#6FA7FF"/>
      </linearGradient>
      <linearGradient id="paint1_linear_284_201" x1="10" y1="5.83334" x2="10" y2="10.8333" gradientUnits="userSpaceOnUse">
        <stop stop-color="#3A86FF"/>
        <stop offset="1" stop-color="#6FA7FF"/>
      </linearGradient>
    </defs>
  </svg>
</i>
</template>
<style scoped>

</style>